import jsonapi from 'jsonapi-parse';

export default $axios => () => ({
    async get() {
        let response = await $axios.get(`/api/v1/me`);
        return jsonapi.parse(response.data).data;
    },

    async getInvoiceRecipient(userId) {
        try {
            let response = await $axios.get(`/rest/finance/recipients/${userId}`);
            return jsonapi.parse(response.data).data;
        } catch (error) {
            return null;
        }
    },

    async update(data) {
        let response = await $axios.put(`/api/v1/me`, data);
        return response;
    },

    async delete() {
        return $axios.delete(`/api/v1/me`);
    },
});
